import React from 'react'
import { inject, observer } from 'mobx-react'

import ProtectedComponent from '../generic/ProtectedComponent'
import MainContent from './MainContent'
import Column from '../generic/Column'
import Columns from '../generic/Columns'
import { BoxCenter } from '../generic/Box'
import Title from '../generic/Title'
import Button from '../generic/Button'
import Table from '../generic/Table'

const Requests = inject('userStore', 'requestsStore', 'companiesStore')(observer(props => {
  const { userStore, requestsStore, companiesStore } = props
  // const { companies } = userStore.state
  const companies = userStore.checkPermission('view_all_requests') ? (
    companiesStore.state.companies
  ) : (
    userStore.state.companies
  )
  const { requests } = requestsStore.state
  const tableHeaders = ['Link', 'Arquivos', 'Download', 'Última modificação']
  return (
    <ProtectedComponent permission='view_requests'>
      <MainContent>
          {companies.map(company => {
            return (
              <Columns key={company.name} isMultiline>
                <Column className='is-12'>
                  <Title>{company.name}</Title>
                </Column>
                {company.products.names.map(product => {
                  const tableRows = requests.get(company.id) && requests.get(company.id).get(product) ? (
                    requests.get(company.id).get(product).data.map(request => {
                      const isDownloaded = company.products[product].data.downloads.includes(request.Key)
                      const title = request.Key.split('/')
                      const link = `https://s3.amazonaws.com/produtosletnis/${request.Key}`
                      const downloadButton = (
                        <Button fieldData={{
                          onClick: () => requestsStore.downloadRequest(link, isDownloaded, request.Key, company.id, product),
                          text: 'Download'
                        }} />
                      )
                      return [downloadButton, title[title.length-1], isDownloaded ? 'Sim' : 'Não',  new Date(request.LastModified).toLocaleString('pt-br')]
                    })
                  ) : (
                    []
                  )
                  const buttonData = {
                    text: 'Visualizar',
                    onClick: () => requestsStore.fetchRequests(company.id, product),
                    isLoading: requests.get(company.id) && requests.get(company.id).get(product) ? (
                      requests.get(company.id) && requests.get(company.id).get(product).isFetching
                    ) : false
                  }
                  const table = requests.get(company.id) && 
                    requests.get(company.id).get(product) && 
                    requests.get(company.id).get(product).isDone ? (
                    <Table headers={tableHeaders} rows={tableRows} />
                  ) : (
                    null
                  )
                  return (
                    <Column key={product}>
                      <BoxCenter>
                        <Title>{product}</Title>
                        {table}
                        <Button fieldData={buttonData} />
                      </BoxCenter>
                    </Column>
                  )
                })}
              </Columns>
            )
          })}
      </MainContent>
    </ProtectedComponent>
  )
}))

export default Requests



// WEBPACK FOOTER //
// ./src/components/dashboard/Requests.js